module.exports = __webpack_public_path__ + "img/reff.c67c2820.svg";